import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	removeSubtaskTitle: {
		id: 'backlog.flags.card-drag-disallowed.remove-subtask-title',
		defaultMessage: "Subtasks can't be moved from their parent on the backlog",
		description:
			'Title for flag that appears when a user tries to remove a subtask from its parent',
	},
	removeSubtaskDescription: {
		id: 'backlog.flags.card-drag-disallowed.remove-subtask-description',
		defaultMessage: 'Select a subtask to view and edit its details',
		description:
			'Description for flag that appears when a user tries to remove a subtask from its parent',
	},
});
